<template>
  <div class="color-picker" ref="colorpicker">
    <CInput type="text" placeholder="#RRGGBB" v-model="color" @focus="showPicker()" @input="updateFromInput">
      <template #append-content>
        <span class="color-picker-container">
	  	  <span class="current-color" :style="'background-color: ' + color" @click="togglePicker()"></span>
	  	  <chrome-picker :value="colors" @input="updateFromPicker" v-if="displayPicker" />
        </span>
      </template>
    </CInput>
  </div>

</template>

<script>
import { Chrome } from 'vue-color'

export default {
  name: 'ColorPicker',
  components: {
    'chrome-picker': Chrome
  },
  props: ['color'],
  data() {
    return {
      colors: { hex: '#000000' },
      colorValue: '',
      displayPicker: false,
    }
  },
  mounted() {
    this.setColor(this.color || '#000000');
  },
  methods: {
    setColor(color) {
      this.updateColors(color)
      this.colorValue = color
    },
    updateColors(color) {
      if(color.slice(0, 1) == '#') {
          this.colors = {
              hex: color
          }
      }
      else if(color.slice(0, 4) == 'rgba') {
          var rgba = color.replace(/^rgba?\(|\s+|\)$/g,'').split(','),
              hex = '#' + ((1 << 24) + (parseInt(rgba[0]) << 16) + (parseInt(rgba[1]) << 8) + parseInt(rgba[2])).toString(16).slice(1)
          this.colors = {
              hex: hex,
              a: rgba[3],
          }
      }
    },
    showPicker() {
      document.addEventListener('click', this.documentClick)
      this.displayPicker = true
    },
    hidePicker() {
      document.removeEventListener('click', this.documentClick)
      this.displayPicker = false
    },
    togglePicker() {
      this.displayPicker ? this.hidePicker() : this.showPicker()
    },
    updateFromInput() {
      this.updateColors(this.colorValue)
    },
    updateFromPicker(color) {
      this.colors = color
      if(color.rgba.a == 1) {
        this.colorValue = color.hex
      }
      else {
        this.colorValue = 'rgba(' + color.rgba.r + ', ' + color.rgba.g + ', ' + color.rgba.b + ', ' + color.rgba.a + ')'
      }
    },
    documentClick(e) {
      var el = this.$refs.colorpicker, target = e.target
      if(el !== target && el !== undefined && !el.contains(target)) {
        this.hidePicker()
      }
    }
  },
  watch: {
    colorValue(val) {
      if(val) {
         this.updateColors(val)
         this.$emit('input', val)
      }
    }
  }
}
</script>
